export enum DiagnosticsLogRangeEnum {
    all = 0,
    recent = 1,
}
